exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".red-hat-bold{font-weight:700}.red-hat-medium{font-weight:500}.red-hat-regular{font-weight:400}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/assets/styles/font-family.css
// module id = 59
// module chunks = 188